<template>
    <v-container >
        <h2>Edit Game </h2>            
        <v-layout row wrap>            
            <v-flex>
                <v-date-picker  color="green lighten-1" v-model="form.date" 
                        @change="onDateChange($event)"></v-date-picker>
            </v-flex>                      
            <v-layout column> 
                <v-flex >
                    <v-select
                        v-model="form.bowler"
                        :items="selecteableActiveBowlers"
                        label=Bowler
                        item-text=name
                        item-value=id
                        @change="onBowlerChange($event)"
                        outline />
                </v-flex>
                <v-flex >
                    <v-select
                        v-model="form.team"
                        :items="activeTeamsForSelect"
                        label=Team
                        item-text=name
                        item-value=id
                        @change="onTeamChange($event)"
                        outline />
                </v-flex>
                <v-flex >
                    <v-select
                        v-model="form.game"
                        :items="games"
                        label=Game
                        item-value=id
                        @change="onGameChange($event)"
                        outline />
                </v-flex>
            </v-layout>            
        </v-layout>
        <v-layout row>
            <v-flex>          
                <v-btn large label="Load Game"  @click="loadGame" >Load this Game</v-btn>
            </v-flex>
            <v-switch
                        v-model="autoSave"
                        :label='autoSave ? "Auto-save On" : "Auto-save Off"'
                    >
            </v-switch>
        </v-layout>
        <v-layout row no-wrap>  
            <v-flex>          
                <frame-editor  ref="frameEditorComponent"  v-on:updated="updatedFromChild"></frame-editor>
            </v-flex>
        </v-layout>        
        <v-layout row no-wrap>  
            <v-flex>          
                <v-btn large label="Submit Game"  @click="submitGame" >Submit Game</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import axios from "axios";
    import FrameEditor from './FrameEditor';
    export default {
        name: 'game-editor',
        components: {
            FrameEditor
        },
        data: function() {
            return {
                frame_no : 1,
                games: [1,2,3],
                form: { 
                    bowler : null, 
                    team: null, 
                    game: null,
                    date: "2021-09-13"
                },
                frames: {
                    0 :null,
                    1 :null,
                    2 :null,
                    3 :null,
                    4: null,
                    5: null,
                    6: null,
                    7: null,
                    8: null,
                    9: null
                },
                autoSave : true
            }
        },
        methods: {
           dbBowlerToFrontendBowler(b){
              return {
                 name: b.first_name + " " + b.last_name,
                 id: b.id,
                 active: b.active,
              }
           },
           dbTeamToFrontendTeam(t){
             return {
                name: `${t.name} (${t.year} ${t.season})`,
                id: t.id
             }
           },
           loadGame(doAlert = true) {
               if( this.form.bowler == null || this.form.team == null || this.form.game == null || this.form.date == null) {
                   if (doAlert) {
                       alert("Need to fill in form first");
                   }
                   return;
               }
               const endpoint = `https://nostyleguy.com/api/bowler_history/${this.form.bowler}/frames/${this.form.date}/${this.form.team}/${this.form.game}`
                axios({
                    method: "GET",
                    url: endpoint,
                    headers: {
                    "content-type": "application/json"
                    }
                }).then(
                    result => {
                        if(result.data.length == 0){
                            if (doAlert) {
                                alert ("Game not found!");
                            }
                        }
                        else{
                            for(const frame of result.data){
                                this.frames[frame.frame -1]=frame
                                this.$refs.frameEditorComponent.LoadFrameData(frame);
                            }
                            if (doAlert) {
                                alert("Success!");
                            }
                        }
                    },
                    error => {
                        alert("Error:" + error);
                    }
                );
           },
           submitGame() {
               for(let i = 0 ; i < 10; i++){
                   this.submitFrame(i);
               }
           },
           submitFrame(i){
               if(this.frames[i] == null){
                   return
               }
               const endpoint = "https://nostyleguy.com/api/bowler_history/" + this.form.bowler.toString() + "/frames"
               const body = {
                   team_id: this.form.team,
                   date: this.form.date,
                   bowler_id: this.form.bowler,
                   game: this.form.game,
                   frame: i+1,
                   first: this.frames[i].first,
                   second: this.frames[i].second,
                   third: this.frames[i].third
                };
                axios({
                    method: "POST",
                    url: endpoint,
                    data: body,
                    headers: {
                    "content-type": "application/json"
                    }
                }).then(
                    result => {
                        //console.log(JSON.stringify(result.data));
                    },
                    error => {
                        //console.log(error);
                    }
                );
           },
           updatedFromChild (data) {
                this.frames[data.frame] = {first : data.first, second: data.second, third: data.third }
                if(this.autoSave){
                    this.submitFrame(data.frame)
                }
            },
            onGameChange(value){
                this.$store.commit("gameeditor_set_game", value)
            },
            onBowlerChange(value){
                this.$store.commit("gameeditor_set_bowler", value)
            },
            onTeamChange(value){
                this.$store.commit("gameeditor_set_team", value)
            },
            onDateChange(value){
                this.$store.commit("gameeditor_set_date", value)
            }
        },
        computed: {
          selecteableActiveBowlers(){
             return this.$store.getters.activeBowlers.map(this.dbBowlerToFrontendBowler);
          },
          activeTeamsForSelect(){
             return this.$store.getters.activeTeams.map(this.dbTeamToFrontendTeam);
          }
       },
       mounted: async function(){
          this.$store.dispatch('getTeams');
          this.$store.dispatch('getBowlers');
          this.form.bowler = this.$store.state.currentGameEditorSettings.bowler;
          this.form.team = this.$store.state.currentGameEditorSettings.team;
          this.form.date = this.$store.state.currentGameEditorSettings.date;
          this.form.game = this.$store.state.currentGameEditorSettings.game;
          this.loadGame(false);
       }
   }
</script>

<style scoped>
</style>